<template>
  <div id="app">
    <header ><div class="header" ><div ><img src="https://www.lefisc.com.br/imagens/lefisc.svg" alt="logo Lefisc" ></div><div class="divider" ></div><div ><h2 @click="pag">Mapa Tributário</h2></div></div></header>
         
      <router-view  />
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return{     
    }
  },
  methods:{   
    pag(){
      window.location = 'https://www.lefisc.com.br/mapatributario/'
    },
  },
  created(){   
    
  }
 
}
</script>

<style>
  .header h2{
    font-size: 20px;
    font-weight: 700;
  }

.divider {
    width: 2px;
    height: 24px;
    background: #333333;
}
  header{
    height: 64px;
    background: #eee;
    display: flex;
    align-items: center;
    justify-content: left;
  }
.meio {
    position: relative;
    top: -60px;
    padding: 40px 80px;
    background: #fff;
    border-radius: 5px;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#app {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
 text-align: center;
  width: 100%;
 text-decoration: none !important;
 
}
.header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: 24px;
}

.top-header{
   
    background-color: #4A154B;
    background-size: cover;
    background-blend-mode: multiply;
    justify-content: center;    
    align-items: flex-start;
    background-repeat: no-repeat;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-position-y: -300px;
    height: 210px;
}
.top-header img{
   width: 340px;
}
</style>
